var _path, _path2, _text, _text2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDscsaCompliant(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 4 H32 V20 Q32 28 18 34 Q4 28 4 20 Z",
    fill: "#2455C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 17 L16.5 22.5 L25.5 11.5",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 42,
    y: 17,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: "bold",
    fontSize: 15,
    fill: "#0F1F38"
  }, "DSCSA")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 42,
    y: 31,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: "bold",
    fontSize: 10.5,
    letterSpacing: 1.6,
    fill: "#4B5B75"
  }, "COMPLIANT")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDscsaCompliant);
export default __webpack_public_path__ + "static/media/dscsaCompliant.5733d213c5ae1ce1633378cc6dd909f5.svg";
export { ForwardRef as ReactComponent };